import { useAdminFetchAccount } from "@portal/api/account/admin";
import { AdminExposureSection } from "@portal/components/features/exposure";
import { Card } from "@portal/components/primitives";
import { FC, type ReactNode } from "react";
import { AccountTabProps } from "../../../AccountLayout";
import { AdminAccountBondsAndRequests } from "./AdminAccountBondsAndRequests";
import { AdminAccountComments } from "./AdminAccountComments";
import { AdminAccountProcessingBanner } from "./AdminAccountProcessingBanner";
import { AdminAccountReviewAndBondingLines } from "./AdminAccountReviewAndBondingLines";
import { AdminUploadedDocuments } from "./AdminUploadedDocuments";

type AdminAccountOverviewTabProps = AccountTabProps;

const SectionStack = ({ children }: { children: ReactNode }) => (
	<div className="flex flex-col space-y-[40px]" data-testid="admin-account-overview-tab">
		{children}
	</div>
);

const ContentCard = ({ children, testId }: { children: ReactNode; testId?: string }) => (
	<Card elevation="raised" className="rounded-xl" data-testid={testId}>
		<Card.Body className="p-6">{children}</Card.Body>
	</Card>
);

export const AdminAccountOverviewTab: FC<AdminAccountOverviewTabProps> = ({ accountId }) => {
	const { account } = useAdminFetchAccount(accountId);

	return (
		<div className="relative min-h-[1050px] pb-16" data-testid="admin-account-overview-card-layout">
			<SectionStack>
				<AdminAccountProcessingBanner accountId={accountId} />
				<AdminAccountReviewAndBondingLines account={account} />
				<AdminExposureSection accountId={accountId} />
				<ContentCard testId="admin-account-bonds-and-requests-card">
					<AdminAccountBondsAndRequests accountId={accountId} />
				</ContentCard>
				<ContentCard testId="admin-account-messages-card">
					<AdminAccountComments account={account} />
				</ContentCard>
				<AdminUploadedDocuments accountId={accountId} />
			</SectionStack>
		</div>
	);
};
